import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC, KeyboardEvent } from 'react';
import type { PodSection } from 'components/molecules/rpm-overview-table/constants';

interface IPodMetadataLineProps {
  podSection: PodSection;
  podName?: string | null;
  podInfoTextColor?: string;
  onClick?: () => void;
}

const PodMetadataLine: FC<IPodMetadataLineProps> = ({
  podSection,
  podName,
  podInfoTextColor,
  onClick,
}) => {
  const { t } = useTranslation();

  if (!podSection || (podSection as string) === 'none') return null;

  const tierLabel = t(`labels.pods.tier.${podSection}`, {
    defaultValue: podSection,
  });

  const ariaLabel = podName
    ? t('labels.pods.metadataAriaLabel', { podName, tierLabel })
    : t('labels.pods.metadataAriaLabelNoName', { tierLabel });

  const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === ' ') {
      event.preventDefault();
      onClick?.();
    } else if (event.key === 'Enter') {
      onClick?.();
    }
  };

  return (
    <span
      className={s['pod-info']}
      style={{ color: podInfoTextColor }}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      data-cy="pod-metadata-line"
      data-testid="pod-metadata-line"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {'• '}
      <span className={s['pod-name-underline']}>{podName}</span>
      <span className={s['pod-tier-label']}>{` (${tierLabel})`}</span>
    </span>
  );
};

export default PodMetadataLine;
